/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface Statistics
 */
export interface Statistics {
    /**
     * 
     * @type {number}
     * @memberof Statistics
     */
    mean?: number;
    /**
     * 
     * @type {number}
     * @memberof Statistics
     */
    standardDeviation?: number;
    /**
     * 
     * @type {number}
     * @memberof Statistics
     */
    minimum?: number;
    /**
     * 
     * @type {number}
     * @memberof Statistics
     */
    maximum?: number;
    /**
     * 
     * @type {number}
     * @memberof Statistics
     */
    median?: number;
    /**
     * 
     * @type {number}
     * @memberof Statistics
     */
    quantile25?: number;
    /**
     * 
     * @type {number}
     * @memberof Statistics
     */
    quantile75?: number;
    /**
     * 
     * @type {string}
     * @memberof Statistics
     */
    $type?: StatisticsTypeEnum;
}


/**
 * @export
 */
export const StatisticsTypeEnum = {
    PtwPtw100AppZeroCoreSharedResultsStatisticsPtwPtw100AppZeroCoreShared: 'Ptw.Ptw100.AppZero.Core.Shared.Results.Statistics, Ptw.Ptw100.AppZero.Core.Shared'
} as const;
export type StatisticsTypeEnum = typeof StatisticsTypeEnum[keyof typeof StatisticsTypeEnum];



/**
 * Check if a given object implements the Statistics interface.
 */
export function instanceOfStatistics(value?: unknown): value is Statistics {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(StatisticsTypeEnum)[0];
}

export function StatisticsFromJSON(json: any): Statistics {
    return StatisticsFromJSONTyped(json, false);
}

export function StatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Statistics {
    if (json == null) {
        return json;
    }
    return {
        
        'mean': json['mean'] == null ? undefined : json['mean'],
        'standardDeviation': json['standardDeviation'] == null ? undefined : json['standardDeviation'],
        'minimum': json['minimum'] == null ? undefined : json['minimum'],
        'maximum': json['maximum'] == null ? undefined : json['maximum'],
        'median': json['median'] == null ? undefined : json['median'],
        'quantile25': json['quantile25'] == null ? undefined : json['quantile25'],
        'quantile75': json['quantile75'] == null ? undefined : json['quantile75'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function StatisticsToJSON(value?: Statistics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'mean': value['mean'],
        'standardDeviation': value['standardDeviation'],
        'minimum': value['minimum'],
        'maximum': value['maximum'],
        'median': value['median'],
        'quantile25': value['quantile25'],
        'quantile75': value['quantile75'],
        '$type': value['$type'],
    });
}

